import classNames from 'classnames';
import { dataLayerPush } from 'app/utilities/gtm';
import Icon from 'app/components/partials/icon';
import PropTypes from 'prop-types';
import { useIdPolyfill } from '../../../hooks/use-id-polyfill';
import React, { useState } from 'react';

const AccordionItem = ({ defaultActive, item }) => {
    const itemId = useIdPolyfill();
    const triggerId = `${itemId}-trigger`;
    const panelId = `${itemId}-content`;
    const [active, setActive] = useState(defaultActive);

    const toggleActive = () => {
        if (!active) {
            /* ↓ Tracking FAQ question expansion events */
            dataLayerPush({
                event: 'conversionTracking',
                category: 'Interaction',
                action: 'FAQ Click',
                label: item.title
            });
            /* ↑ Tracking FAQ question expansion events */
        }

        setActive(!active);
    };

    const itemClass = classNames('item', {
        'is-active': active
    });

    return (
        <div className={itemClass}>
            <h3>
                <button
                    id={triggerId}
                    className="heading"
                    type="button"
                    onClick={toggleActive}
                    aria-expanded={active}
                    aria-controls={panelId}
                >
                    <span className="h4 title-text">{item.title}</span>
                    <Icon name="chevron" />
                </button>
            </h3>
            <div id={panelId} role="region" aria-labelledby={triggerId} hidden={!active}>
                {/* unused? */}
                {item.information && <p className="information || rich-editor-content" dangerouslySetInnerHTML={{ __html:item.information }}></p>}
                {typeof item.content === 'string' && <div className="content || rich-editor-content" dangerouslySetInnerHTML={{ __html:item.content }}></div>}
                {typeof item.content === 'object' && (
                    <div className="content">
                        {item.content}
                    </div>
                )}
            </div>
            <hr />
        </div>
    );
};

AccordionItem.defaultProps = {
    defaultActive: false,
};

AccordionItem.propTypes = {
    defaultActive: PropTypes.bool,
    item: PropTypes.object.isRequired
};

export default AccordionItem;
